import { ChakraProvider, useTheme as useThemeChakra } from "@chakra-ui/react";
import React from "react";

import useFeatureFlag from "../../main/graphql/hooks/useFeatureFlag";
import usePlanFeatureFlag from "../../plan/graphql/hooks/useFeatureFlag";
import theme, { interTheme, Theme } from "../../theme";
import type { ColorModeManager } from "../../theme/colorModeManager";

interface ThemedChakraProviderProps {
  children: React.ReactNode;
  themeOverride?: Theme;
  interThemeOverride?: Theme;
  colorModeManager?: ColorModeManager;
}

export const ThemedChakraProvider: React.FC<ThemedChakraProviderProps> = ({
  children,
  themeOverride,
  interThemeOverride,
  colorModeManager,
}) => {
  const isInterInterview = useFeatureFlag("inter");
  const isInterPlan = usePlanFeatureFlag("inter");
  const isInter = isInterInterview || isInterPlan;
  const resolvedTheme = themeOverride ?? theme;
  const resolvedInterTheme = interThemeOverride ?? interTheme;
  return (
    <ChakraProvider
      theme={isInter ? resolvedInterTheme : resolvedTheme}
      colorModeManager={colorModeManager}
    >
      {children}
    </ChakraProvider>
  );
};

export const StorybookThemedChakraProvider: React.FC<
  ThemedChakraProviderProps
> = ({ children, themeOverride, interThemeOverride, colorModeManager }) => {
  const isInterInterview = useFeatureFlag("inter");
  const isInterPlan = usePlanFeatureFlag("inter");
  const isInter = isInterInterview || isInterPlan;
  const resolvedTheme = themeOverride ?? theme;
  const resolvedInterTheme = interThemeOverride ?? interTheme;
  return (
    <ChakraProvider
      theme={isInter ? resolvedInterTheme : resolvedTheme}
      colorModeManager={colorModeManager}
    >
      {children}
    </ChakraProvider>
  );
};

export const useTheme = (): Theme => {
  return useThemeChakra<Theme>();
};

export type { Theme };
